module.exports = __webpack_public_path__ + "img/Slider.09a099a6.webp";